module.exports = "/assets/data/4cea54c1b739c02cfc19e28c15cd1c5d-OX9.data.json";